/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptioncreator3Inputs */



/**
* | output |
* | --- |
* | "You see the world as a canvas. You love creating beauty around you, generating ideas, and turning everyday moments into art or killer content." |
*
* @param {Personalityarchetypedescriptioncreator3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptioncreator3 = /** @type {((inputs?: Personalityarchetypedescriptioncreator3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptioncreator3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You see the world as a canvas. You love creating beauty around you, generating ideas, and turning everyday moments into art or killer content.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ves el mundo como un lienzo. Te encanta crear belleza a tu alrededor, generar ideas y convertir momentos cotidianos en arte o contenido genial.")
	return /** @type {LocalizedString} */ ("Ты видишь мир как холст. Тебе нравится создавать красоту вокруг себя, генерировать идеи и превращать обычные моменты в искусство или классный контент.")
});
export { personalityarchetypedescriptioncreator3 as "personalityArchetypeDescriptionCreator" }